import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ProfileDetailRowProps {
  icon: LucideIcon
  label: string
  value: string
  href?: string
  className?: string
}

export function ProfileDetailRow({
  icon: Icon,
  label,
  value,
  href,
  className,
}: ProfileDetailRowProps) {
  const content = (
    <div className={cn('flex items-center gap-4 px-4 py-3.5', className)}>
      <div className="flex size-9 shrink-0 items-center justify-center rounded border border-border-2 bg-card">
        <Icon className="size-4 text-muted-foreground" strokeWidth={1.75} aria-hidden />
      </div>
      <div className="min-w-0 flex-1 py-0.5">
        <p className="font-sans text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
          {label}
        </p>
        <p className="mt-0.5 truncate font-sans text-sm text-ink">{value}</p>
      </div>
    </div>
  )

  if (href) {
    return (
      <a href={href} className="block transition-colors hover:bg-cream-2/50">
        {content}
      </a>
    )
  }

  return <div>{content}</div>
}
